import { createFileRoute } from '@tanstack/react-router';
import { MappingsPage } from '@/features/foodcost/MappingsPage';

export const Route = createFileRoute('/_app/foodcost/mappature')({ component: MappingsPage });
